module.exports = __webpack_public_path__ + "img/future-hustlers-elements.42ec6bd0.png";